<template>
  <section class="p-2">
    <div id="app">
      <v-card class="">
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">Sanction List</div>
          <div>
            <bread-crumb :bread-crumbs="['Sanction List']" />
          </div>
        </v-card-title>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
        <v-tabs v-model="sanctiontype" slider-color="primary" centered>
          <v-tab
            v-for="item in items"
            :key="item.key"
            :href="'#' + item.key"
            class="text-capitalize text-decoration-none"
          >
            {{ item.label }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="sanctiontype">
          <v-tab-item id="Sanction-vue">
            <sanctionListupload />
          </v-tab-item>
          <v-tab-item id="History-vue">
            <sanctionListhistory />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
  </section>
</template>

<script>
import sanctionListupload from "../BlackList/sanctionListupload";
import sanctionListhistory from "../BlackList/sanctionListhistory"
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Sanction List",
  data: () => {
    return {
      sanctiontype: "Sanction",
      items: [
        { label: "Sanction Upload", key: "Sanction-vue" },
        { label: "Sanction Upload History", key: "History-vue" },
      ],
    };
  },
  components: {
    BreadCrumb,
    sanctionListupload,
    sanctionListhistory,
  },
};
</script>

<style></style>
